import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { NgClass } from '@angular/common';
import { TefBoxService } from '../../services/tef-box-service';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogService } from '../../services/confirm-dialog-service';
import { Button } from '../../components/button/button';
import { ConfirmDialog } from '../../components/confirm-dialog/confirm-dialog';
import { HasRolesDirective } from 'keycloak-angular';
import Keycloak from 'keycloak-js';
import { ClienteService } from '../../services/cliente-service';
import { Badge } from '../../components/badge/badge';
import { KeyViewer } from '../../components/key-viewer/key-viewer';

@Component({
  selector: 'app-settings',
  imports: [
    NgClass,
    ReactiveFormsModule,
    Button,
    ConfirmDialog,
    HasRolesDirective,
    Badge,
    KeyViewer,
  ],
  templateUrl: './settings.html',
  styleUrl: './settings.scss',
})
export class Settings implements OnInit {
  keycloak = inject(Keycloak);
  isClient = false;

  tabs = [
    { id: 1, title: 'Geral', visibility: ['lojista', 'admin'] },
    { id: 2, title: 'Configurações', visibility: ['cliente', 'lojista', 'admin'] },
    { id: 4, title: 'Segurança', visibility: ['cliente', 'admin'] },
  ];

  activeTab = 2;

  userInfo = new FormGroup({
    clientId: new FormControl(''),
    cnpj: new FormControl(''),
    merchantId: new FormControl(''),
    merchantLabel: new FormControl(''),
  });

  showConfirmDialog = false;
  message = 'Tem certeza disso?';

  tokens = Array.from({ length: 30 }).map((_, idx) => ({
    token: crypto.randomUUID(),
    expires: 1,
    merchantLabel: `Merchant ${idx + 1}`,
    cnpj: '11111',
    merchantId: '111',
  }));

  @ViewChild('cnpjInput') meuInput!: ElementRef<HTMLInputElement>;

  constructor(
    private tefBoxService: TefBoxService,
    private clienteService: ClienteService,
    private confirmDialogService: ConfirmDialogService,
  ) {
    this.confirmDialogService.showDialog$.subscribe(({ message }) => {
      this.showConfirmDialog = true;
    });
  }

  ngOnInit(): void {
    this.isClient = this.keycloak.hasResourceRole('cliente', 'tefbox-api-lojista');

    this.getUserInfo();

    this.getMerchant();

    this.userInfo.disable();
  }

  onConfirm() {
    this.confirmDialogService.confirm();
    this.showConfirmDialog = false;
  }

  onCancel() {
    this.confirmDialogService.cancel();
    this.showConfirmDialog = false;
  }

  selectTab(tabId: number) {
    this.activeTab = tabId;
  }

  getUserInfo() {
    if (this.isClient) {
      this.clienteService.getClientInfo().subscribe((x) => {
        this.userInfo.setValue({
          clientId: x[0].clientId,
          cnpj: x[0].cnpj,
          merchantId: x[0].merchantId,
          merchantLabel: x[0].merchantLabel,
        });
      });
    } else {
      this.tefBoxService.getUserInfo().subscribe((x) => {
        this.userInfo.setValue({
          clientId: x.clientId,
          cnpj: x.cnpj,
          merchantId: x.merchantId,
          merchantLabel: x.merchantLabel,
        });
      });
    }
  }

  getMerchant() {
    if (this.isClient) {
      this.clienteService.getMerchants().subscribe((x) => {
        this.tokens = x.map((item) => ({
          token: item.token,
          merchantLabel: item.merchantLabel,
          cnpj: item.cnpj,
          merchantId: item.merchantId,
          expires: item.expires,
        }));
      });
    }
  }

  updateToken(merchantId: string) {
    this.clienteService.updateToken(merchantId).subscribe({
      next: () => {
        this.getMerchant();
      },
    });
  }

  statusToken(expires: number): boolean {
    const timestamp = Math.floor(Date.now() / 1000);

    return expires - timestamp > 0;
  }

  editCNPJ() {
    this.userInfo.controls.cnpj.enable();
    this.meuInput.nativeElement.focus();
  }

  salvar() {
    this.confirmDialogService.requestConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        alert('ok');
      }
    });
  }

  formatCNPJ(value: string | number): string {
    // Garante que estamos trabalhando com string e remove tudo que não é número
    const digits = value.toString().replace(/\D/g, '');

    // Limita a 14 dígitos (CNPJ válido)
    const cnpj = digits.slice(0, 14);

    // Aplica a máscara de CNPJ: 00.000.000/0000-00
    return cnpj
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }
}
